import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./PrivacyPolicy.css";

const PartnerWithUs = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-page">
      <button className="back-btn" onClick={() => navigate('/')}>
        <FaArrowLeft />
      </button>

      <h1>Partner With Discount Dost</h1>
      <h2>Gain More Customers. Build Loyalty. Grow Your Revenue.</h2>

      <p>
        Running a business is challenging — but with Discount Dost, it gets a whole lot easier.
        We help you attract foot traffic, increase repeat visits, and create loyal fans by combining irresistible local deals with a unique twist: digital gold rewards.
      </p>

      <h2>Why Partner with Discount Dost?</h2>
      <ol>
        <li>
          <strong>Attract High-Intent Shoppers:</strong> Our users are on the lookout for great deals nearby.
          When your store appears with a Discount Dost offer, you instantly grab attention.
          <br /><em>“It’s like having a personal billboard in every user’s pocket.”</em>
        </li>
        <li>
          <strong>Outshine Your Competitors:</strong> Discounts are common — but gold rewards? That’s powerful.
          You’re not just offering savings; you’re offering wealth-building incentives your competitors can’t match.
        </li>
        <li>
          <strong>Turn One-Time Visitors Into Loyal Fans:</strong> Encourage repeat business with tiered loyalty rewards — the more they visit, the more gold they earn. It’s loyalty, gamified.
        </li>
        <li>
          <strong>No Upfront Costs, No Surprises:</strong> Forget long-term contracts or hidden charges.
          You only pay a small commission after a successful transaction. No risk — just results.
        </li>
        <li>
          <strong>Real-Time Analytics & Smart Dashboard:</strong> Stay in control with an easy-to-use dashboard.
          Track redemptions, footfall, and performance trends to double down on what works best.
        </li>
      </ol>

      <h2>Who Can Join?</h2>
      <p>We welcome a wide range of quality local businesses:</p>
      <ul>
        <li>Cafés & Restaurants</li>
        <li>Salons & Spas</li>
        <li>Boutiques & Retail Shops</li>
        <li>Gyms & Fitness Studios</li>
        <li>Clinics & Wellness Centers</li>
        <li>Local Services (Repair, Laundry, etc.)</li>
      </ul>
      <p>If you're focused on quality and growth, you belong in the Discount Dost network.</p>

      <h2>How It Works for Merchants</h2>
      <p><strong>Simple, Transparent, and Rewarding</strong></p>
      <ol>
        <li>
          <strong>Post Your Deal:</strong> Submit an exclusive discount offer for your business through our merchant dashboard. Think of it as your digital storefront for thousands of nearby customers.
        </li>
        <li>
          <strong>Approval & Promotion:</strong> Once your deal is approved, it gets promoted across our web, app, and social channels.
        </li>
        <li>
          <strong>Customers Buy Online:</strong> They pre-purchase deals and get a digital coupon.
        </li>
        <li>
          <strong>Customers Redeem at Your Premises:</strong> They show the coupon in-store — you verify it via your dashboard.
        </li>
        <li>
          <strong>Instant Payout to You:</strong> After you click "Redeem," payment is credited to you immediately. No delays.
        </li>
      </ol>

      <h2>100% Accountability & Secure Transactions</h2>
      <p>
        Every coupon is tracked and validated by Discount Dost. You’re protected from fraud and always paid for valid redemptions.
      </p>

      <h2>A Win-Win for Everyone</h2>
      <ul>
        <li>You gain new and repeat customers</li>
        <li>Customers get discounts + digital gold</li>
        <li>As gold appreciates, so does customer loyalty</li>
        <li>They can redeem gold for real 24K any time</li>
        <li>Every transaction creates real value for both sides</li>
      </ul>

      <h2>Let’s Chat</h2>
      <p>
        Want to see how Discount Dost can work for your business?
        <br />
        <strong>Schedule a free 15-min consultation</strong>
        <br />
        Contact us here: <Link to="/ContactForm" className="contact-link">Click Here</Link>
      </p>
    </div>
  );
};

export default PartnerWithUs;
